import React, {useState} from 'react';
import Box from "@mui/material/Box";
import ProfileHeader from "../../../components/ProfileHeader";
import {Trans} from "react-i18next";
import {getSessionStorage} from "../../../utils/StorageUtil";
import {TOKEN_SO_KEY} from "../../../utils/accountUtils";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import {Form, Formik} from "formik";
import OutlinedTextField from "../../../components/formFields/OutlinedTextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import UnitsApi from "../../../api/UnitsApi";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {Snackbar} from "@mui/material";
import Alert from "@mui/material/Alert";

const validationSchema = Yup.object().shape({
  domain: Yup.string()
    .min(6, `screens.searchVehicles.sections.searchDomain.fieldminCharacters`)
})

function Index() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);

  const handleSubmit = (values: any, actions: any) => {
    UnitsApi.get(values.domain).then(resp => {
      if (resp.status !== 200) {
        setAlert(true);
      }else{
        if(resp?.data?.id) {
          navigate(`/web/checklist-list/${resp.data.id}/${resp.data.numberPlate}`)
        }
      }
    })
  }

  const handleClose = () => {
    setAlert(false);
  };
  return (
    <Box>
      <ProfileHeader></ProfileHeader>
      <Box sx={{ margin: '0 4%' }}>
        <Box className="search-vehicles-title">
          <Trans i18nKey={`screens.searchVehicles.titleCheckList`} />
        </Box>
        <Box className="search-vehicles-card">
          <Formik
            initialValues={{ domain: '' }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            isInitialValid={false}
          >
            {({ isSubmitting, isValid }) => (
              <Form
                id="domai-search"
                style={{ display: 'flex', alignItems: 'flex-start' }}
              >
                <OutlinedTextField
                  label={`screens.searchVehicles.sections.searchDomain.fieldPlaceholder`}
                  extraLabel={`screens.searchVehicles.sections.searchDomain.fieldHelpText`}
                  name="domain"
                  autoComplete="domain"
                  fullWidth={true}
                  i18n
                  sx={{ marginRight: '10px' }}
                />
                <IconButton
                  disabled={!isValid}
                  type="submit"
                  className="search-vehicles-icon-button"
                >
                  <SearchIcon />
                </IconButton>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
      {getSessionStorage(TOKEN_SO_KEY) !== null && (
        <ProfileBottomNav goBack={true} />
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={alert}
        onClose={handleClose}
        key="alert-domain"
        autoHideDuration={6000}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          <Trans i18nKey={`screens.notFoundUnitDialog.title`}  />
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default Index;
